import { FC } from 'react';
import { Stack } from '@mui/material';
import { Link } from 'react-router-dom';

import { routes } from 'src/constants/routes';

import { BookingMoveInDetails } from '../../../types/booking-move-in-details';

import { MoveInDayInner } from './move-in-day-inner';

export const MoveInDay: FC<{ moveInDetails: BookingMoveInDetails; isMainOccupant: boolean }> = ({
    moveInDetails,
    isMainOccupant,
}) => {
    if (isMainOccupant) {
        return (
            <Stack
                component={Link}
                to={routes.moveInDay.index}
                css={{
                    padding: 0,
                    width: '100%',
                    borderRadius: 0,
                    textDecoration: 'inherit',
                    color: 'inherit',
                    ':hover': {
                        '[aria-label="link title"]': {
                            ':after': {
                                width: '100%',
                            },
                        },
                    },
                }}
            >
                <MoveInDayInner moveInDetails={moveInDetails} isMainOccupant />
            </Stack>
        );
    }

    return <MoveInDayInner moveInDetails={moveInDetails} isMainOccupant={false} />;
};
